
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">{{statusForConfirmation.statusForConfirmation}} Configuration</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div>
    <div >Are you sure you want <font color="red"><strong> {{statusForConfirmation.statusForConfirmation}} </strong></font> this configuration?</div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="activateDeactivateConfiguration()">{{statusForConfirmation.statusForConfirmation}}</button>
    <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
  </div>
</div>
</div>
